<template>
  <div>
    <el-form
      :model="reportsForm"
      class="employee-form form"
      :rules="rules"
      ref="reportsForm"
      label-position="left"
      label-width="180px"
    >
      <h3 class="bold mb-40">{{ titleText }} Report</h3>

      <!-- <div class="mt-20 mb-20">
        <el-form-item label="Select Report" class="ml-0">
          <el-select v-model="reportsForm.report" placeholder="">
            <el-option
              v-for="item in allReport"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div> -->

      <p class="bold">Date Filter</p>

      <div class="mt-20 mb-20">
        <el-form-item label="Select Date" prop="monthYear" class="ml-0">
          <el-date-picker
            v-model="reportsForm.monthYear"
            type="month"
            placeholder=""
          >
          </el-date-picker>
        </el-form-item>
      </div>

      <button
        class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mt-40"
        @click.prevent="generatePayslip()"
      >
        <span>Generate Report</span>
      </button>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      reportsForm: {
        monthYear: null,
      },
      rules: {
        monthYear: [{ required: true, message: "Please pick a date" }],
      },
    };
  },
  methods: {
    generatePayslip() {
      this.$refs[`reportsForm`].validate(valid => {
        if (!valid) {
          return;
        }

        const reportParams = {
          month: this.reportsForm.monthYear.getMonth() + 1,
          year: this.reportsForm.monthYear.getFullYear(),
        };
        this.$emit("generatePayslip", reportParams);
        this.$router.push({
          name: "payslip",
          params: { reportParams },
        });
      });
    },
  },
};
</script>
